import { serializeTransaction } from "viem";
import { TransactionStatus, TransactionType, } from "../../apollo/graphql.generated";
import { logError } from "../../services/logger";
import { GetPendingEvmTransactionsDocument, GetRecentEvmTransactionsDocument, } from "../tx-history/queries.graphql.generated";
import { useCreateEvm721AuctionTransactionMutation, useCreateEvm721BidTransactionMutation, useCreateEvm721MintTransactionMutation, useCreateEvmApproveTransferTransactionMutation, useCreateEvmApproveTransferWrappedTransactionMutation, useCreateEvmDeployTransactionMutation, useCreateEvmDepositFundsTransactionMutation, useCreateEvmMintCreatorReservesTransactionMutation, useCreateEvmSaleTransactionMutation, useCreateEvmUpdateCollectionTransactionMutation, useUpdateEvm721AuctionTransactionMutation, useUpdateEvm721BidTransactionMutation, useUpdateEvm721MintTransactionMutation, useUpdateEvmApproveTransferTxMutation, useUpdateEvmApproveTransferWrappedTxMutation, useUpdateEvmCreateMintVectorTransactionMutation, useUpdateEvmDeployTransactionMutation, useUpdateEvmDepositFundsTxMutation, useUpdateEvmMintCreatorReservesTransactionMutation, useUpdateEvmSaleTxMutation, useUpdateEvmUpdateCollectionTransactionMutation, } from "./queries.graphql.generated";
export const useBackendTxQueries = (handleCreateSuccess, handleUpdateSuccess, handleError) => {
    const [createEvm721MintTransaction, { data: createEvm721MintTransactionData, error: createEvm721MintTransactionError, },] = useCreateEvm721MintTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "CREATE_EVM_TX_ERROR");
        },
    });
    const [updateEvm721MintTransaction, { data: updateEvm721MintTransactionData, error: updateEvm721MintTransactionError, },] = useUpdateEvm721MintTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvm721MintTx.evmTxGraphql.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvm721BidTransaction, { data: createEvm721BidTransactionData, error: createEvm721BidTransactionError, },] = useCreateEvm721BidTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "CREATE_EVM_TX_ERROR");
        },
    });
    const [updateEvm721BidTransaction, { data: updateEvm721BidTransactionData, error: updateEvm721BidTransactionError, },] = useUpdateEvm721BidTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvm721BidTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvm721AuctionTransaction, { data: createEvm721AuctionTransactionData, error: createEvm721AuctionTransactionError, },] = useCreateEvm721AuctionTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "CREATE_EVM_TX_ERROR");
        },
    });
    const [updateEvm721AuctionTransaction, { data: updateEvm721AuctionTransactionData, error: updateEvm721AuctionTransactionError, },] = useUpdateEvm721AuctionTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvm721AuctionTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmDeployTransaction, { data: createEvmDeployTransactionData, error: createEvmDeployTransactionError, },] = useCreateEvmDeployTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "CREATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmDeployTransaction, { data: updateEvmDeployTransactionData, error: updateEvmDeployTransactionError, },] = useUpdateEvmDeployTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmDeployTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmUpdateCollectionTransaction, { data: createEvmUpdateCollectionTransactionData, error: createEvmUpdateCollectionTransactionError, },] = useCreateEvmUpdateCollectionTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "CREATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmUpdateCollectionTransaction, { data: updateEvmUpdateCollectionTransactionData, error: updateEvmUpdateCollectionTransactionError, },] = useUpdateEvmUpdateCollectionTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmUpdateCollectionTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmMintCreatorReservesTransaction, { data: createEvmMintCreatorReservesTransactionData, error: createEvmMintCreatorReservesTransactionError, },] = useCreateEvmMintCreatorReservesTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "CREATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmMintCreatorReservesTransaction, { data: updateEvmMintCreatorReservesTransactionData, error: updateEvmMintCreatorReservesTransactionError, },] = useUpdateEvmMintCreatorReservesTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmMintCreatorReservesTx.evmTxGraphql.status ===
                TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmCreateMintVectorTransaction, { data: updateEvmCreateMintVectorTransactionData, error: updateEvmCreateMintVectorTransactionError, },] = useUpdateEvmCreateMintVectorTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmCreateMintVectorTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmSaleTx, { data: updateEvmSaleTxData, error: updateEvmSaleTxError },] = useUpdateEvmSaleTxMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmSaleTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmApproveTransferTx, { data: updateEvmApproveTransferTxData, error: updateEvmApproveTransferTxError, },] = useUpdateEvmApproveTransferTxMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmApproveTransferTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmApproveTransferWrappedTx, { data: updateEvmApproveTransferWrappedTxData, error: updateEvmApproveTransferWrappedTxError, },] = useUpdateEvmApproveTransferWrappedTxMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmApproveTransferWrappedTx.status ===
                TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [updateEvmDepositFundsTx, { data: updateEvmDepositFundsTxData, error: updateEvmDepositFundsTxError },] = useUpdateEvmDepositFundsTxMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            if (data.updateEvmDepositFundsTx.status === TransactionStatus.MINED) {
                handleUpdateSuccess(data);
            }
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmSaleTransaction, { data: createEvmSaleTransactionData, error: createEvmSaleTransactionError, },] = useCreateEvmSaleTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmApproveTransferTransaction, { data: createEvmApproveTransferTransactionData, error: createEvmApproveTransferTransactionError, },] = useCreateEvmApproveTransferTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmApproveTransferWrappedTransaction, { data: createEvmApproveTransferWrappedTransactionData, error: createEvmApproveTransferWrappedTransactionError, },] = useCreateEvmApproveTransferWrappedTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const [createEvmDepositFundsTransaction, { data: createEvmDepositFundsTransactionData, error: createEvmDepositFundsTransactionError, },] = useCreateEvmDepositFundsTransactionMutation({
        refetchQueries: [
            GetPendingEvmTransactionsDocument,
            GetRecentEvmTransactionsDocument,
        ],
        onCompleted(data) {
            handleCreateSuccess(data);
        },
        onError(err) {
            handleError(err, "UPDATE_EVM_TX_ERROR");
        },
    });
    const serializeTx = (tx) => {
        try {
            return serializeTransaction({
                chainId: tx.chainId,
                nonce: tx.nonce,
                maxFeePerGas: tx.maxFeePerGas,
                maxPriorityFeePerGas: tx.maxPriorityFeePerGas,
                type: tx.type,
                to: tx.to ? tx.to : undefined,
                from: tx.from,
                hash: tx.hash,
                value: tx.value,
            });
        }
        catch (err) {
            logError({
                err,
                message: `error serializing transaction ${JSON.stringify(tx)}`,
            });
            throw err;
        }
    };
    const createEvmTx = (tx, type, metadata, crossChainId, relayerId) => {
        console.log({ tx, type, metadata }, "About to create transaction");
        if (type === TransactionType.EVM_DEPLOY_COLLECTION) {
            createEvmDeployTransaction({
                variables: {
                    data: {
                        ...metadata,
                        serializedTx: serializeTx(tx),
                        from: tx.from,
                        hash: tx.hash,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_721_MINT) {
            createEvm721MintTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                        crossChainId,
                        relayerId,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_721_BID) {
            createEvm721BidTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                        crossChainId,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_721_AUCTION) {
            createEvm721AuctionTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                        crossChainId,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_UPDATE_ROYALTY ||
            type === TransactionType.EVM_SET_BASE_URI ||
            type === TransactionType.EVM_UPDATE_METADATA ||
            type === TransactionType.EVM_UPDATE_MINT_VECTOR ||
            type === TransactionType.EVM_CREATE_MINT_VECTOR ||
            type === TransactionType.EVM_CREATE_MECHANIC_VECTOR ||
            type === TransactionType.EVM_UPDATE_DUTCH_AUCTION_VECTOR ||
            type === TransactionType.EVM_DUTCH_AUCTION_REBATE) {
            createEvmUpdateCollectionTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_MINT_CREATOR_RESERVES) {
            createEvmMintCreatorReservesTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_TOKEN_SALE) {
            createEvmSaleTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_APPROVE_TRANSFER) {
            createEvmApproveTransferTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_APPROVE_TRANSFER_WRAPPED) {
            createEvmApproveTransferWrappedTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                    },
                },
            });
        }
        if (type === TransactionType.EVM_DEPOSIT_FUNDS) {
            createEvmDepositFundsTransaction({
                variables: {
                    input: {
                        serializedTx: serializeTx(tx),
                        ...metadata,
                        from: tx.from,
                        hash: tx.hash,
                        amount: tx.value.toString(),
                    },
                },
            });
        }
    };
    const updateEvmTx = (txHash, type) => {
        console.log({ txHash, type }, "About to update transaction");
        if (type === TransactionType.EVM_DEPLOY_COLLECTION) {
            updateEvmDeployTransaction({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_721_MINT) {
            updateEvm721MintTransaction({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_721_BID) {
            updateEvm721BidTransaction({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_721_AUCTION) {
            updateEvm721AuctionTransaction({
                variables: { txHash },
            });
        }
        if ([
            TransactionType.EVM_UPDATE_ROYALTY,
            TransactionType.EVM_UPDATE_METADATA,
            TransactionType.EVM_SET_BASE_URI,
            TransactionType.EVM_UPDATE_MINT_VECTOR,
            TransactionType.EVM_UPDATE_DUTCH_AUCTION_VECTOR,
            TransactionType.EVM_DUTCH_AUCTION_REBATE,
        ].includes(type)) {
            updateEvmUpdateCollectionTransaction({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_CREATE_MINT_VECTOR ||
            type === TransactionType.EVM_CREATE_MECHANIC_VECTOR) {
            updateEvmCreateMintVectorTransaction({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_MINT_CREATOR_RESERVES) {
            updateEvmMintCreatorReservesTransaction({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_TOKEN_SALE) {
            updateEvmSaleTx({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_APPROVE_TRANSFER) {
            updateEvmApproveTransferTx({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_APPROVE_TRANSFER_WRAPPED) {
            updateEvmApproveTransferWrappedTx({
                variables: { txHash },
            });
        }
        if (type === TransactionType.EVM_DEPOSIT_FUNDS) {
            updateEvmDepositFundsTx({
                variables: { txHash },
            });
        }
    };
    return {
        createEvmTx,
        updateEvmTx,
        data: {
            create: {
                createEvmDeployTransactionData,
                createEvm721MintTransactionData,
                createEvm721BidTransactionData,
                createEvm721AuctionTransactionData,
                createEvmUpdateCollectionTransactionData,
                createEvmMintCreatorReservesTransactionData,
                createEvmSaleTransactionData,
                createEvmApproveTransferTransactionData,
                createEvmApproveTransferWrappedTransactionData,
                createEvmDepositFundsTransactionData,
            },
            update: {
                updateEvmDeployTransactionData,
                updateEvm721MintTransactionData,
                updateEvm721BidTransactionData,
                updateEvm721AuctionTransactionData,
                updateEvmUpdateCollectionTransactionData,
                updateEvmMintCreatorReservesTransactionData,
                updateEvmCreateMintVectorTransactionData,
                updateEvmSaleTxData,
                updateEvmApproveTransferTxData,
                updateEvmApproveTransferWrappedTxData,
                updateEvmDepositFundsTxData,
            },
        },
        error: {
            create: {
                createEvmDeployTransactionError,
                createEvm721MintTransactionError,
                createEvm721BidTransactionError,
                createEvm721AuctionTransactionError,
                createEvmUpdateCollectionTransactionError,
                createEvmMintCreatorReservesTransactionError,
                createEvmSaleTransactionError,
                createEvmApproveTransferTransactionError,
                createEvmApproveTransferWrappedTransactionError,
                createEvmDepositFundsTransactionError,
            },
            update: {
                updateEvmDeployTransactionError,
                updateEvm721MintTransactionError,
                updateEvm721BidTransactionError,
                updateEvm721AuctionTransactionError,
                updateEvmUpdateCollectionTransactionError,
                updateEvmMintCreatorReservesTransactionError,
                updateEvmCreateMintVectorTransactionError,
                updateEvmSaleTxError,
                updateEvmApproveTransferTxError,
                updateEvmApproveTransferWrappedTxError,
                updateEvmDepositFundsTxError,
            },
        },
        serializeTx,
    };
};
